<template>
  <f7-page class="home-page">
    <template #fixed>
      <MainHeaderComponent />
    </template>

    <div class="bg-gray title-container">
      <div class="title">
        <font-awesome-icon :icon="['fad', 'chart-area']" fixed-width />
        <div class="text">
          <h1>{{ $t.getTranslation("LBL_NOTIFICATIONS") }}</h1>
          <h3></h3>
        </div>
      </div>

      <div v-show="false" class="button-container">
        <f7-button large fill raised>Actions</f7-button>
        <f7-button large icon="far fa-fw fa-cog"></f7-button>
      </div>

      <div class="button-container">
        <f7-button large fill raised @click="create">{{ $t.getTranslation("LBL_CREATE") }}</f7-button>
      </div>
    </div>

    <DataTableComponent :columns="columns" :size="10" :url="url" @editItem="editItem"></DataTableComponent>

    <MainFooterComponent />
  </f7-page>
</template>

<script>
import { defineComponent, inject, computed } from "vue";

import MainHeaderComponent from "@/components/MainHeaderComponent.vue";
import MainFooterComponent from "@/components/MainFooterComponent.vue";
import DataTableComponent from "@/components/DataTableComponent.vue";
import { useStore } from "@/store";
import { $HTTP } from "@/utils/axios";
import { helpers } from "@/utils/helpers";
export default defineComponent({
  name: "BlankPage",
  components: {
    MainHeaderComponent,
    MainFooterComponent,
    DataTableComponent,
  },
  props: { f7router: Object },
  setup(props) {
    const $t = inject("$translation");
    const store = useStore();

    const columns = [
      {
        title: $t.getTranslation("LBL_TITLE"),
        minWidth: 160,
        field: "Title",
      },
      {
        title: $t.getTranslation("LBL_CONTENT"),
        minWidth: 160,
        field: "Content",
      },
      {
        title: $t.getTranslation("LBL_TYPE"),
        minWidth: 160,
        field: "Type",
      },
      {
        title: $t.getTranslation("LBL_USER_GROUP"),
        minWidth: 160,
        field: "GroupName",
      },
      {
        title: $t.getTranslation("LBL_STATUS"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
              <div class="chip ${cell.getData()?.StatusCode === "ACTIVE" ? "color-green" : "color-gray"}">
                <div class="chip-label">${cell.getData()?.StatusName || "--"}</div>
              </div>
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_DATE_CREATED"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
              ${helpers.formatDateTime(cell.getData().LastCreated)}
            </div>
          `;
        },
      },
    ];

    const editItem = (data) => {
      if (data?.value?.NotificationId) {
        props.f7router.navigate({ name: "notificationSave", query: { NotificationId: data.value.NotificationId } });
      }
    };

    const create = () => {
      props.f7router.navigate({ name: "notificationSave", query: {} });
    };

    let url = `/admin/notification/list`;
    return {
      columns,
      url,
      editItem,
      create,
    };
  },
});
</script>

<style scoped>
.custom-container {
  min-height: 600px;
}
</style>
